export const popupsArr = [
  { text: 'Как узнать, какую песню можно посоветовать другу?' },
  { text: 'Мы узнаем, что человеку точно нравится. А затем, опираясь на свой опыт, подбираем что-то подходящее.' },
  { text: 'А что значит "подходящее"?' },
  { text: 'Это или похожее на то, что уже нравится, или связанное с ним. А ещё, если ты можешь посмотреть все соцсети друзей, то можешь найти тех, у кого общие интересы. Так ты узнаешь, какие песни и кому можно предложить.' },
  { text: 'Соедини линией друзей с одинаковыми интересами. Ты узнаешь их, если у них в профилях по два одинаковых певца.', buttonTitle: 'Начать' },
]
export const popupsArr2 = [
  { text: 'Отлично! Молодец!' },
  { text: 'Задание: перенеси карточку песни тем профилям, кому ее можно рекомендовать.', buttonTitle: 'Начать' },
]

export const popupsArr3 = [
  { text: 'Согласен с твоим выбором.' },
  { text: 'Так песни очень быстро расходятся по большому количеству людей, но при этом рекомендуются только тем, кому они могут понравиться.', buttonTitle: 'Продолжить' },
  // { text: 'Так и получается, что новая музыка рекомендуется только тем, кому она может понравиться. Но при этом очень быстро расходится большому количеству людей.', buttonTitle: 'Продолжить' },
]
export const popupsErr = [
  { text: 'Рекомендуй песню тем, у кого есть в профиле ЗайЗай и связанным с ними профилям.', buttonTitle: 'Повторить' },
]
export const popupsErr2 = [
  { text: 'Будь внимательнее.', buttonTitle: 'Продолжить' },
]

export const task1 = [
  { text: 'Соедини линией друзей с одинаковыми интересами. Ты узнаешь их, если у них в профилях по два одинаковых певца.' },
]
export const task2 = [
  { text: 'Задание: перенеси карточку песни тем профилям, кому ее можно рекомендовать.' },
]

export const billet = [
  {
    title: 'ЗайЗай', img: 'hare', subtitle: 'Морковная история', key: 'c', key2: 'b',
  },
  {
    title: 'ЗайЗай', img: 'hare', subtitle: 'Морковная история', key: 'b', key2: 'c',
  },
  {
    title: 'ЗайЗай', img: 'hare', subtitle: 'Морковная история', key: 'b', key2: 'c',
  },
  {
    title: 'ЗайЗай', img: 'hare', subtitle: 'Морковная история', key: 'b', key2: 'c',
  },
]

export const arrBlocks = [
  [
    {
      author: 'avatar1', singers: [{ img: 'dog' }, { img: 'bear' }, { img: 'catOrange' }], key: 'a', arr: [], circle: { executor: 'a', cx: 13, cy: 13 },
    },
    {
      author: 'avatar2', singers: [{ img: 'cat' }, { img: 'hare' }, { img: 'panda' }], key: 'b', arr: [], circle: { executor: 'b', cx: 297, cy: 13 },
    },
    {
      author: 'avatar3', singers: [{ img: 'tiger' }, { img: 'koala' }, { img: 'frog' }], key: 'c', arr: [], circle: { executor: 'c', cx: 582, cy: 13 },
    },
    {
      author: 'avatar4', singers: [{ img: 'cat' }, { img: 'bear' }, { img: 'frog' }], key: 'd', arr: [], circle: { executor: 'd', cx: 867, cy: 13 },
    },
  ],

  [
    {
      author: 'avatar5', singers: [{ img: 'dog' }, { img: 'mouse' }, { img: 'catOrange' }], key: 'a', arr: [], reverse: true, circle: { executor: 'a', cx: 13, cy: 119 },
    },
    {
      author: 'avatar7', singers: [{ img: 'panda' }, { img: 'cat' }, { img: 'dog' }], key: 'b', arr: [], reverse: true, circle: { executor: 'b', cx: 582, cy: 119 },
    },
    {
      author: 'avatar8', singers: [{ img: 'hare' }, { img: 'koala' }, { img: 'tiger' }], key: 'c', arr: [], reverse: true, circle: { executor: 'c', cx: 867, cy: 119 },
    },
    {
      author: 'avatar6', singers: [{ img: 'frog' }, { img: 'bear' }, { img: 'panda' }], key: 'd', arr: [], reverse: true, circle: { executor: 'd', cx: 297, cy: 119 },
    },
  ],
]
